module.exports = __webpack_public_path__ + "static/hero-bg-217ff9a737d101ee875d4166e427cc44.png";